var SELOPLIST = 'selopList';
var MustSelList = 'mutSelList';
export var seloptions = {
  namespaced: true,
  state: {
    selopList: '',
    mutSelList: []
  },
  mutations: {
    //单选
    setSelectOptions: function setSelectOptions(state, selopList) {
      window.localStorage.setItem(SELOPLIST, selopList);
      state.selopList = selopList;
    },
    //多选
    setMutSelectOptions: function setMutSelectOptions(state, mutSelList) {
      window.localStorage.setItem(MustSelList, mutSelList);
      state.mutSelList = mutSelList;
    }
  },
  actions: {},
  getters: {
    //单选
    getSelectOptions: function getSelectOptions(state) {
      state.selopList = window.localStorage.getItem(SELOPLIST);
      return state.selopList;
    },
    //多选
    getMutSelectOptions: function getMutSelectOptions(state) {
      state.mutSelList = window.localStorage.getItem(MustSelList);
      if (state.mutSelList.length !== 0) {
        return state.mutSelList.split(',');
      } else {
        return state.mutSelList;
      }
    }
  }
};